export default __webpack_public_path__ + "static/media/collapse-828282.01ebf681.svg";